import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// The Featuring card's date picker: one calendar in range mode, from the
// placement's first allowed day, with its full days disabled. The chosen
// first and last day go into the form's hidden start and end fields.
export default class extends Controller {
  static targets = ["input", "start", "end"]
  static values = { minDate: String, maxDate: String, busyDates: Array }

  connect() {
    this.picker = flatpickr(this.inputTarget, {
      mode: "range",
      inline: true,
      dateFormat: "Y-m-d",
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
      disable: this.busyDatesValue,
      defaultDate: [this.startTarget.value, this.endTarget.value].filter(Boolean),
      onChange: (dates) => this.#store(dates)
    })
  }

  disconnect() {
    this.picker?.destroy()
  }

  // One day clicked: a one-day run until a second day is chosen.
  #store([first, last]) {
    this.startTarget.value = first ? this.#format(first) : ""
    this.endTarget.value = (last || first) ? this.#format(last || first) : ""
  }

  #format(date) {
    return this.picker.formatDate(date, "Y-m-d")
  }
}
